import { DeleteIcon, EditIcon, SearchIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Td,
  Text,
  Tooltip,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

const NewsItem = ({ onDelete, news }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{news.title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex w={"90%"} gap={3} flexDir={"column"}>
              <Text>
                {news.authorName} -{" "}
                {format(new Date(news.createdAt), "dd/MM/yyyy")}
              </Text>
              <Text
                dangerouslySetInnerHTML={{
                  __html: news.text.replace(/(?:\r\n|\r|\n)/g, "<br>"),
                }}
              />
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Voltar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Tr>
        <Td>{news.title}</Td>
        <Td>Ir∴ {news.authorName}</Td>
        <Td>{format(new Date(news.createdAt), "dd/MM/yyyy")}</Td>
        <Td>{!news?.comments?.length ? "0" : news.comments.length}</Td>

        <Td>
          <Flex gap={5}>
            <Tooltip label={"Detalhes"}>
              <IconButton
                colorScheme="blue"
                aria-label="Detalhes"
                size="sm"
                onClick={onOpen}
                icon={<SearchIcon />}
              />
            </Tooltip>
            <Tooltip label={"Editar notícia"}>
              <IconButton
                colorScheme="yellow" // Escolha uma cor diferente da exclusão para distinguir ações
                aria-label="Editar"
                size="sm"
                icon={<EditIcon />}
                onClick={() => {
                  navigate(`/editar_noticia/${news.newsId}`); // Ajuste a rota conforme sua aplicação
                }}
              />
            </Tooltip>
            <Tooltip label={"Editar notícia"}>
              <IconButton
                colorScheme="red"
                aria-label="Excluir"
                size="sm"
                isLoading={isLoading}
                onClick={() => {
                  setIsLoading(true);
                  onDelete(news.newsId);
                }}
                icon={<DeleteIcon />}
              />
            </Tooltip>
          </Flex>
        </Td>
      </Tr>
    </>
  );
};
export default NewsItem;
